define("shared/utils/plans-data/legacy-plans", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  /**
   * @module Utils
   */

  /**
   * @class legacyPlanssUtil
   * @extends Utils
   */

  /**
   * Stores dataset on legacy plans of plans service
   *
   * @method legacyPlans
   * @param {Service} intl
   *
   * @returns {Array} Legacy plans data of plans service
   */

  const legacyPlans = intl => [{
    monthlyPrice: '9',
    monthlyPriceBilledYearly: '7.5',
    canonicalName: 'plus',
    name: 'Plus',
    price: '9',
    annualPrice: '$7.5',
    migrationPlan: 'starter',
    migrationHighlights: [intl.t('plans.migrate.legacy.plus.feature_1'), intl.t('plans.migrate.legacy.plus.feature_2'), intl.t('plans.migrate.legacy.plus.feature_3')],
    reactivationHighlights: [intl.t('plans.highlight_mappings.stories'), intl.t('plans.highlight_mappings.multi_photo'), intl.t('plans.highlight_mappings.tagging'), intl.t('plans.highlight_mappings.first_comment')]
  }, {
    monthlyPrice: '19',
    monthlyPriceBilledYearly: '16',
    canonicalName: 'premium',
    name: 'Premium',
    price: '19',
    annualPrice: '$16',
    migrationPlan: 'growth',
    migrationHighlights: [intl.t('plans.migrate.legacy.premium.feature_1'), intl.t('plans.migrate.legacy.premium.feature_2'), intl.t('plans.migrate.legacy.premium.feature_3')],
    reactivationHighlights: [intl.t('plans.highlight_mappings.stories'), intl.t('plans.highlight_mappings.linkinbio_standard'), intl.t('plans.highlight_mappings.analytics_standard'), intl.t('plans.highlight_mappings.first_comment'), intl.t('plans.highlight_mappings.collect')]
  }, {
    canonicalName: 'starter',
    name: 'Starter',
    price: '29',
    annualPrice: '$24',
    migrationPlan: 'growth',
    migrationHighlights: [intl.t('plans.migrate.legacy.starter.feature_1'), intl.t('shared_phrases.unlimited_posts'), intl.t('plans.migrate.legacy.starter.feature_3')],
    reactivationHighlights: [intl.t('plans.highlight_mappings.stories'), intl.t('plans.highlight_mappings.linkinbio_standard'), intl.t('plans.highlight_mappings.analytics_standard'), intl.t('plans.highlight_mappings.first_comment'), intl.t('plans.highlight_mappings.collect')]
  }, {
    monthlyPrice: '49',
    monthlyPriceBilledYearly: '41',
    canonicalName: 'brand',
    name: 'Brand',
    price: '49',
    annualPrice: '$41',
    migrationPlan: 'growth',
    migrationHighlights: [intl.t('plans.migrate.legacy.brand.feature_1'), intl.t('shared_phrases.unlimited_posts'), intl.t('plans.migrate.legacy.brand.feature_3')],
    reactivationHighlights: [intl.t('plans.highlight_mappings.stories'), intl.t('plans.highlight_mappings.linkinbio_standard'), intl.t('plans.highlight_mappings.analytics_standard'), intl.t('plans.highlight_mappings.first_comment'), intl.t('plans.highlight_mappings.collect')]
  }];
  var _default = _exports.default = legacyPlans;
});